import './App.css';
import Home from './Home/Home/Home';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Projects from './Pages/Projects/Projects';
import ContactMe from './Pages/ContactMe/ContactMe';
import Details from './Pages/Details/Details';
import Blogs from './Pages/Blogs/Blogs';
import AboutMe from './Pages/AboutMe/AboutMe';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<ContactMe />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="//aboutme" element={<AboutMe />} />
          <Route path="/projects/:projectId" element={<Details />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
